export default __webpack_public_path__ + "static/media/plus-white.08305557.svg";